import axios from 'axios';
import { Url } from './constantUrl';
import getHeaders from './getHeaders';
import * as types from './types';
import { errorHandler } from './error/errorHandler.action';

// Get DBT Configuration
export const getDbtConfigAction = () => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.DBT_CONFIGURATION}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_DBT_CONFIGURATION, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};

// Update DBT Configuration
export const updateDbtConfigAction = (payload) => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.DBT_CONFIGURATION}`;
  const options = {
    method: 'POST',
    headers: getHeaders(),
    url: url,
    data: payload
  };

  return axios(options)
    .then(response => {
      if (response.status === 200 || response.status === 201) {
        dispatch({ type: types.POST_DBT_CONFIGURATION, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
      throw error;
    });
};
